import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import PopupForm from "components/form/PopupForm";

import { SaveContextProvider } from "context/save";

import usePopupForm from "hooks/form/usePopupForm";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Popup aggiornato con successo",
        errorMsg: "Errore nell'aggiornamento del popup",
        navigateTo: { link: "/dashboard" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaPopupInner() {
    const formPopupHook = usePopupForm();

    return (
        <>
            <PopupForm formPopupHook={formPopupHook} />
            <ButtonSave />
        </>
    );
}

function ModificaPopup() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Popup</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ModificaPopupInner />
            </SaveContextProvider>
        </Fragment>
    );
}

export default ModificaPopup;
